import { GET_COLEGIATURAS_LIST } from "./ColegiaturasAction";

let initialState = {
    getColegiaturasList:           false,
    errorColegiaturasList:         false,
};

const ColegiaturasReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_COLEGIATURAS_LIST:
            return {
                ...state,
                getColegiaturasList: action.payload.data,
                errorColegiaturasList: action.payload.errorMessage,
            };

        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default ColegiaturasReducer;